var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "boardPage" },
    [
      _c(
        "div",
        {
          class: _vm.oneselfPlatform ? "platform" : "",
          attrs: { id: "video_student_list" },
        },
        [
          _vm._l(_vm.stuRemoteStreamList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                class:
                  item.id == "i" ? "my_video student_video" : "student_video",
                attrs: {
                  id: item.stream.getId(),
                  oncontextmenu: "return false;",
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.currentVideoPlay(item, index)) +
                    "\n            "
                ),
                _vm._v(" "),
                item.id !== "i"
                  ? _c("span", { staticClass: "student_name" }, [
                      _vm._v(_vm._s(item.name)),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$refs.settingsDialog.show()
                },
              },
            },
            [_vm._v("设备")]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", {
        staticStyle: { "background-color": "rgb(240, 240, 240)" },
        attrs: { id: "paint_box" },
      }),
      _vm._v(" "),
      _c("SettingDialog", {
        ref: "settingsDialog",
        attrs: { cameraStream: _vm.cameraStream },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/board/board.vue?vue&type=template&id=0f2037d3&
// module id = null
// module chunks = 